import { useCallback } from "react";
import {
  useRouteError,
  useLocation,
  useRevalidator,
} from "react-router-dom";
import { ErrorPageContent } from "@/components/ErrorPageContent";

export default function ErrorPage() {
  const error = useRouteError();
  const location = useLocation();
  const { revalidate } = useRevalidator();

  const handleRetry = useCallback(() => {
    void revalidate();
  }, [revalidate]);

  return (
    <ErrorPageContent
      error={error}
      pathname={location.pathname}
      onRetry={handleRetry}
    />
  );
}
